import { useEffect, useState } from 'react';
import { registerPushSubscription } from '../../../utils/pushNotifications';

export function useShowNotificationPrompt() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const asked = localStorage.getItem('pushAsked');
    if (asked === 'yes') return;

    if (!('Notification' in window)) return;
    if (!('serviceWorker' in navigator)) return;
    if (!('PushManager' in window)) return;

    setOpen(true);
  }, []);

  const handleEnable = async () => {
    try {
      setLoading(true);
      await registerPushSubscription();
      localStorage.setItem('pushAsked', 'yes');
      setOpen(false);
    } catch (e) {
      alert('Не удалось включить уведомления');
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    localStorage.setItem('pushAsked', 'yes');
    setOpen(false);
  };

  return { open, loading, handleEnable, handleSkip };
}
